import { Card, CardBody, Col } from "reactstrap";
import { TextColor} from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { TEXTCOLOR_DATA, TEXT_COLOR } from "../../../../Data/UiKit/Typography";
import { P } from "../../../../AbstractElements";

const TextColorCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={TextColor} span={TEXTCOLOR_DATA} />
        <CardBody>
          <div className="d-flex flex-column gap-2">
            <P className="txt-primary mb-0">
              This is Primary Color text
              <code>.txt_primary</code> Class
            </P>
            {TEXT_COLOR.map(({ title, code }, index) => (
              <P className={`${code} mb-0`} key={index}>
                {`This is ${title} Color Text`}
                <code>.{code}</code> Class
              </P>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TextColorCart;
